import { createContext, useState } from "react";
import { getMe } from "../services/auth";
const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState({});
  const [bots, setBots] = useState([]);
  const [botSelected, setBotSelected] = useState({});
  const [log, setLog] = useState(getMe() !== null ? true : false);
  const [server, setServer] = useState("");

  const saveToken = (token) => {
    setLog(true);
    localStorage.setItem("jwt", token);
  };

  const deleteToken = () => {
    setLog(false);
    localStorage.removeItem("jwt");
    // localStorage.removeItem("bot");
  };
  return (
    <AuthContext.Provider
      value={{
        log,
        setLog,
        saveToken,
        deleteToken,
        user,
        setUser,
        bots,
        setBots,
        setBotSelected,
        botSelected,
        server,
        setServer
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
